import * as React from 'react'
import { inject, observer } from 'mobx-react'
import RootStore from '../../../../../../stores/RootStore'
import ReportsItem from '../reports-item/ReportsItem'
import ReportsGroupItem from '../reports-item/ReportsGroupItem'
import { useHistory } from 'react-router-dom'

import './ReportsList.scss'
import { IOrderClient } from '@tfo/common/src/models/Interfaces'

export interface ReportsListProps {
	rootStore?: RootStore
}

const ReportsList = (props: ReportsListProps) => {
	const history = useHistory()
	const store = props.rootStore!.clientViewStore!
	const reportPackages = props.rootStore.clientViewStore.activeReportPackages

	const onGoToGroupOrder = (groupOderId: number) => {
		history.push({ pathname: `/grouporder/${groupOderId}` })
	}

	const onGoToReport = async (order: IOrderClient) => {
		history.push({ pathname: `/read-report/${order.id}` })
	}

	return (
		<> {store.reportsStore &&
			<div className="ReportsList">
				<div className="ReportsList__Inner">
					<div className="ReportsList__Table">
						{store.reportsStore.getGroupOrders?.map((item, index) => {
							return (
								<ReportsGroupItem
									data={item}
									key={'reportsItem_' + item.id + index}
									onClick={() => onGoToGroupOrder(item.id)}
									reportPackages={reportPackages}
									store={store}
								/>
							)
						})}
						{store.reportsStore.getVisibleOrders?.map((item, index) => {
							return (
								<ReportsItem
									data={item}
									key={'reportsItem_' + item.id + index}
									onClick={() => onGoToReport(item)}
									reportPackages={reportPackages}
									store={store}
								/>
							)
						})}
					</div>
				</div>
			</div>
		}
		</>
	)
}

export default inject('rootStore')(observer(ReportsList))
